"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Copyright (c) Hathor Labs and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

class Header {
  // XXX In typescript we can't have an abstract and static method
  static deserialize(srcBuf, network) {
    throw new Error('Not implemented: deserialize must be implemented in subclass');
  }
}
exports.default = Header;